/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  color: rgba(0, 0, 0, 0.85);
  font-size: ${scale.minor(5)}px;
  font-weight: 500;
  line-height: ${scale.minor(7)}px;
  margin-bottom: ${scale.minor(1)}px;
`;
